import { render, staticRenderFns } from "./DeliveryZoneInfo.vue?vue&type=template&id=7ba1acee&scoped=true"
import script from "./DeliveryZoneInfo.vue?vue&type=script&lang=js"
export * from "./DeliveryZoneInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba1acee",
  null
  
)

export default component.exports